module.exports = __webpack_public_path__ + "img/envelope.c82416b9.svg";